"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsDefaultWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsDefaultWrapper";
import type { ApiWave } from "@/generated/models/ApiWave";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { useRef, useState } from "react";
import WaveDelete from "./delete/WaveDelete";
import WaveMute from "./mute/WaveMute";
import WaveProfileWaveAction from "./profile-wave/WaveProfileWaveAction";
export default function WaveHeaderOptions(t0) {
  const $ = _c(22);
  const {
    wave
  } = t0;
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const buttonRef = useRef(null);
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.stopPropagation();
      setIsOptionsOpen(_temp);
    };
    t2 = <span className="tw-sr-only">Open options</span>;
    t3 = <EllipsisVerticalIcon className="tw-size-4 tw-flex-shrink-0" aria-hidden="true" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isOptionsOpen) {
    t4 = <button ref={buttonRef} type="button" className="tw-flex tw-size-9 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-300 desktop-hover:hover:tw-ring-1 desktop-hover:hover:tw-ring-inset desktop-hover:hover:tw-ring-iron-700" id="options-menu-0-button" aria-expanded={isOptionsOpen} aria-haspopup="true" onClick={t1}>{t2}{t3}</button>;
    $[3] = isOptionsOpen;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsOptionsOpen(false);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== wave) {
    t6 = <WaveProfileWaveAction wave={wave} onSuccess={t5} />;
    $[6] = wave;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsOptionsOpen(false);
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  let t9;
  if ($[9] !== wave) {
    t8 = <WaveMute wave={wave} onSuccess={t7} />;
    t9 = <WaveDelete wave={wave} />;
    $[9] = wave;
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6 || $[13] !== t8 || $[14] !== t9) {
    t10 = <li className="tw-list-none"><div className="tw-flex tw-flex-col tw-gap-y-0.5 tw-py-1">{t6}{t8}{t9}</div></li>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== isOptionsOpen || $[17] !== t10) {
    t11 = <CommonDropdownItemsDefaultWrapper isOpen={isOptionsOpen} setOpen={setIsOptionsOpen} buttonRef={buttonRef}>{t10}</CommonDropdownItemsDefaultWrapper>;
    $[16] = isOptionsOpen;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t4) {
    t12 = <div className="tw-relative tw-z-20">{t4}{t11}</div>;
    $[19] = t11;
    $[20] = t4;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function _temp(open) {
  return !open;
}